'use client'

import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import apiService from '@/app/services/apiService'

export default function AvatarUpload() {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null)
  const [preview, setPreview] = useState<string | null>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const user = await apiService.getWithToken('/api/user/me/')
        setAvatarUrl(user.avatar_url || null)
      } catch (error) {
        toast.error('Erro ao carregar avatar.')
      }
    }

    fetchUserInfo()
  }, [])

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setSelectedFile(file)
      setPreview(URL.createObjectURL(file))
    }
  }

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('Selecione uma imagem primeiro.')
      return
    }

    setLoading(true)
    const formData = new FormData()
    formData.append('avatar', selectedFile)

    try {
      const response = await apiService.postWithTokenFormData('/api/user/avatar/', formData, true)
      setAvatarUrl(response.avatar_url)
      toast.success('Avatar atualizado com sucesso!')
    } catch (error) {
      toast.error('Erro ao fazer upload do avatar.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-6 max-w-xl">
      <div className="flex items-center space-x-4">
        <img
          src={preview || avatarUrl || '/images/default-avatar.png'}
          alt="Avatar"
          className="w-24 h-24 rounded-full border object-cover"
        />
        <label className="inline-flex items-center justify-center px-4 py-2 bg-brand-700 text-white rounded-md cursor-pointer hover:bg-brand-800 transition w-fit">
          📤 Upload Avatar
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
      </label>
      </div>

      <button
        onClick={handleUpload}
        disabled={loading || !selectedFile}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition disabled:opacity-50"
      >
        {loading ? 'Enviando...' : 'Atualizar avatar'}
      </button>
    </div>
  )
}
